import { StanButton } from '@/components';

interface FormActionsProps {
    isLastStep: boolean;
    isDisabled: boolean;
    isLoading: boolean;
    onAction: () => void;
}

export const FormActions = ({ isLastStep, isDisabled, isLoading, onAction }: FormActionsProps) => {
    const buttonLabel = isLastStep ? 'Create Your First Email' : 'Next';

    return (
        <div className='flex w-full justify-end'>
            <StanButton name='add-flow-button' onClick={onAction} disabled={isDisabled} loading={isLoading} size='md'>
                {buttonLabel}
            </StanButton>
        </div>
    );
};
